import { render } from "./LanguageButton.vue?vue&type=template&id=311e5cd4&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=js"
export * from "./LanguageButton.vue?vue&type=script&lang=js"

import "./LanguageButton.vue?vue&type=style&index=0&id=311e5cd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311e5cd4"]])

export default __exports__